function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.03117 15H15C16.6569 15 18 16.3432 18 18V29C18 30.6569 16.6569 32 15 32H3C1.34315 32 0 30.6569 0 29V22.1803V15.7869V15H0.019268C0.429293 6.64672 7.33188 0 15.7869 0V6C10.6466 6 6.4319 9.96281 6.03117 15ZM22 22.1803V15.7869V15H22.0193C22.4293 6.64672 29.3319 0 37.7869 0V6C32.6466 6 28.4319 9.96281 28.0312 15H37C38.6569 15 40 16.3432 40 18V29C40 30.6569 38.6569 32 37 32H25C23.3431 32 22 30.6569 22 29V22.1803Z",
  fill: "#C6E3E0"
});

var SvgQuotes = function SvgQuotes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotes.e17def3c.svg";
export { ForwardRef as ReactComponent };